<template>
	<svg
		:height="radius * 2"
		:width="radius * 2"
	>
		<circle
			stroke="#EDEDED"
			:stroke-dasharray="circumferenceFull + ' ' + circumferenceFull"
			:stroke-width="stroke"
			fill="transparent"
			:r="normalizedRadius"
			:cx="radius"
			:cy="radius"
		/>
		<circle
			:stroke="getColor()"
			:stroke-dasharray="circumference + ' ' + circumference"
			:style="{ strokeDashoffset: strokeDashoffset }"
			:stroke-width="stroke"
			fill="transparent"
			:r="normalizedRadius"
			:cx="radius"
			:cy="radius"
		/>

	</svg>
</template>

<script>
export default {
	name: "SOProgressBarCircle",
	props: {
		radius: Number,
		progress: Number,
		stroke: Number,

		green: Boolean,
		blue: Boolean,
		yellow: Boolean,
	},
	data() {
		const normalizedRadius = this.radius - this.stroke * 2;
		const circumference = normalizedRadius * 2 * Math.PI;
		const circumferenceFull = normalizedRadius * 2 * Math.PI;

		return {
			normalizedRadius,
			circumference,
			circumferenceFull,
		};
	},
	computed: {
		strokeDashoffset() {
			return this.circumference - this.progress / 100 * this.circumference;
		}
	},
	// mounted() {
	// 	// emulating progress
	// 	const interval = setInterval(() => {
	// 		this.progress += 10;
	// 		if (this.progress === 100)
	// 			clearInterval(interval);
	// 	}, 1000);
	// },
	methods: {
		getColor() {
			if (this.green) {
				return "#84E08A"
			} else if (this.blue) {
				return "#80A9FF"
			} else if (this.yellow) {
				return "#F2D68E"
			}
		}
	}
}
</script>

<style>
circle {
	transition: stroke-dashoffset 0.35s;
	transform: rotate(-90deg);
	transform-origin: 50% 50%;
}
</style>